import { render } from "./app-dialog-action.vue?vue&type=template&id=53d34142"
import script from "./app-dialog-action.vue?vue&type=script&lang=js"
export * from "./app-dialog-action.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__